import { ItemMenu } from '../../../../../components/baseMenu'
import { Status } from '../../../../../utils/enums'

const menuItems: ItemMenu[] = [
  {
    label: 'Ver detalle',
    value: 5,
  },
  {
    label: 'Editar agendamiento',
    value: 1,
  },
  {
    label: 'Eliminar agendamiento',
    value: 8,
  },
  {
    label: 'Cancelar agendamiento',
    value: 2,
  },
  {
    label: 'Editar serie',
    value: 6,
  },
  {
    label: 'Eliminar serie',
    value: 7,
  },
  {
    label: 'Ver reporte',
    value: 3,
  },
  {
    label: 'Reenviar reporte',
    value: 4,
  },
]

const menuList: Record<string, number[]> = {
  [Status.TO_BE_STARTED]: [1, 2, 5, 6, 7, 8],
  [Status.STARTED]: [2, 5, 7, 8],
  [Status.PAUSE]: [2, 5, 7, 8],
  [Status.EXPIRED]: [2, 5, 7, 8],
  [Status.INCOMPLETE]: [2, 5, 7, 8],
  [Status.FINISHED]: [4, 3, 5, 7, 8],
  [Status.CANCEL]: [5, 7, 8],
  [Status.CLOSE]: [5, 7, 8],
  [Status.WAITING]: [2, 5, 7, 8],
}
export { menuItems, menuList }
